import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './fields.scss';
import { GECKO_UTILS } from '../../';
import GeckoField from './field.jsx';
import { GeckoFieldsModel } from '../../models';

class GeckoFields extends Component {
  // Check if field should be hidden
  isHidden(field) {
    return field.hideWhen ? field.hideWhen() : false;
  }

  renderClasses(field) {
    return GECKO_UTILS.classNames({
      'form-group col-12': true,
      [field.class]: field.class,
    });
  }

  renderStyles(field) {
    let styles = {};

    // Add field width
    if (field.width) styles['flex'] = '0 0 ' + field.width;
    // Add default width
    if (!field.width) styles['flex'] = '0 0 50%';
    // Break onto new line (ALLAN INSISTED ON FLEXBOX AND THIS NO LONGER WORKS!!!)
    //if (field.break) styles['clear'] = 'both';
    return styles;
  }

  renderField(field, i) {
    if (!this.isHidden(field)) {
      return (
        <div
          className={this.renderClasses(field)}
          style={this.renderStyles(field)}
          key={i}
        >
          <GeckoField
            field={field}
            values={this.props.values}
            handler={this.props.handler.bind(this)}
          />
        </div>
      );
    }
    return null;
  }

  submitForm(event) {
    // Stop the form from reloading the page
    event.preventDefault();
    // Fire custom submit handler
    return this.props.submitHandler();
  }

  render() {
    return (
      <form className="gecko-fields" onSubmit={this.submitForm.bind(this)}>
        {this.props.fields.map((field, i) => this.renderField(field, i))}
        <input className="gecko-submit-input" type="submit" />
      </form>
    );
  }
}

GeckoFields.defaultProps = {
  fields: [],
  values: {},
  handler: () => {},
  submitHandler: () => {},
};

GeckoFields.propTypes = {
  fields: GeckoFieldsModel.isRequired,
  values: PropTypes.object,
  handler: PropTypes.func,
  submitHandler: PropTypes.func,
};

export default GeckoFields;
